import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components';
import * as toastr from "toastr";

import * as playAudio from "Placements/Assets/svg/playAudio.svg";
import * as pauseButton from "Placements/Assets/svg/pauseButton.svg";

const AudioPlayer = styled.div`
    border: none;
    background: 0 0;
    position: relative;
    margin-top: -30px;
    width: 420px;

    .jp-interface{
        display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: start;
        justify-content: flex-start;
        height: auto;
        background-color: transparent;
        z-index: 2;

        :before{
            content: "";
            padding: 0;
            background-color: #66279b;
            height: 40px;
            width: calc(100% - 250px);
            display: -webkit-box;
            display: flex;
            position: absolute;
            left: 72px;
            top: 14px;
            z-index: -1;
        }

        .jp-controls{
            padding: 0;
            background-color: #1fbfd9;
            height: 80px;
            width: 80px;
            display: -webkit-box;
            display: flex;
            position: relative;
            overflow: inherit;
            z-index: 2;

            :before{

                content: "";
                padding: 0;
                background-color: #66279b;
                height: 80px;
                width: 80px;
                display: -webkit-box;
                display: flex;
                position: absolute;
                left: -8px;
                top: -8px;
                z-index: -1;

            }

            button{
                float: none;
                height: 80px;
                width: 80px;
                display: block;
                float: left;
                overflow: hidden;
                text-indent: -9999px;
                border: none;
                cursor: pointer;
                background: center/40% no-repeat #1fbfd9;
            }

        }

        .progress-holder{
            display: -webkit-box;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            width: calc(100% - 80px);
            height: 40px;
            background-color: #1fbfd9;
            position: relative;
            left: -2px;

            .jp-progress{
                width: calc(100% - 40px);
                top: auto;
                height: 3px;
                position: absolute;
                left: 20px;
                overflow: hidden;
                background-color: #ddd;

                .jp-seek-bar{
                    background: #fff;
                    z-index: 2;
                    width: 100%;
                    height: 100%;
                    cursor: pointer;
    
                    .jp-play-bar{
                        background: #66279b;
                        z-index: 2;
                        height: 100%;
                    }
                }
            }
        }

        @media (max-width: 768px){

            width: 100%;
            margin-top: -20px;

            .jp-controls{
                height: 60px;
                width: 60px;
                left: -6px;
                top: -6px;

                :before{
                    height: 60px;
                    width: 60px;
                    left: -5px;
                    top: -5px;
                }

                button{
                    height: 60px;
                    width: 60px;
                }
            }

            .jp-interface{
            
                :before{
                    width: calc(100% - 250px);
                    left: 40px;
                    top: 3px;
                    height: 30px;
                }
                
            }

            .progress-holder{
                width: calc(100% - 250px);
                left: -8px;
                height: 30px;
                top: -8px;
            }
            
        }

    }
`;

type AudioPlayerProps = {
    src: string
}

const AudioPlayerPlacement = ({src}: AudioPlayerProps) => {

    const [isPaused, setPaused] = useState(true);
    const [audioProgress, setAudioProgress] = useState(0);
    const audioRef = useRef(null);

    useEffect(() => {

        if(audioRef !== null)
            audioRef.current.ontimeupdate = () => {
                setAudioProgress(audioRef.current.currentTime / audioRef.current.duration * 100);

                if(audioRef.current.currentTime === audioRef.current.duration){

                    audioRef.current.currentTime = 0;
                    audioRef.current.pause();
                    setPaused(true);

                }

            }  

    }, [audioRef]);

    const handlePlayPause = () => {
        
        if(isNaN(audioRef.current.duration)){

            toastr.error("Não foi possível obter o audio.");

        } else {

            if(audioRef.current.paused){

                audioRef.current.play();
                setPaused(false);
    
            } else {
    
                audioRef.current.pause();
                setPaused(true);
    
            }

        }

    }

    const handleAudioClick = (e: any) => {

        if(isNaN(audioRef.current.duration)){

            toastr.error("Não foi possível obter o audio.");

        } else {

            const rect = e.target.getBoundingClientRect();

            const progress = (e.clientX - rect.left) * 100 / 300;
            audioRef.current.currentTime = (audioRef.current.duration * progress) / 100;

            setAudioProgress(progress);

        }

    }

    return(
        <div>
            <audio src={src} ref={audioRef}></audio>
            <AudioPlayer>
                <div className="jp-interface">
                    <div className="jp-controls">
                        <button onClick={handlePlayPause} style={{backgroundImage: `url(${isPaused ? playAudio : pauseButton})`}}></button>
                    </div>
                    <div className="progress-holder">
                        <div className="jp-progress" onMouseUp={handleAudioClick}>
                            <div className="jp-seek-bar">
                                <div className="jp-play-bar" style={{width: `${audioProgress}%`}}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </AudioPlayer>
        </div>
    );

}

export default AudioPlayerPlacement;